export const levelXPTable = [
  {
    level: "1",
    incrementXP: 0,
    cumulativeXP: 0,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "2",
    incrementXP: 100,
    cumulativeXP: 100,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "3",
    incrementXP: 105,
    cumulativeXP: 205,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "4",
    incrementXP: 110,
    cumulativeXP: 315,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "5",
    incrementXP: 115,
    cumulativeXP: 430,
    badge: false,
    reward: true,
    issueCardPack: true,
    infinityOnly: true,
  },
  {
    level: "6",
    incrementXP: 121,
    cumulativeXP: 551,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "7",
    incrementXP: 127,
    cumulativeXP: 678,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "8",
    incrementXP: 134,
    cumulativeXP: 812,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "9",
    incrementXP: 140,
    cumulativeXP: 952,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "10",
    incrementXP: 147,
    cumulativeXP: 1099,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "11",
    incrementXP: 155,
    cumulativeXP: 1254,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "12",
    incrementXP: 162,
    cumulativeXP: 1416,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "13",
    incrementXP: 171,
    cumulativeXP: 1587,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "14",
    incrementXP: 179,
    cumulativeXP: 1766,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "15",
    incrementXP: 188,
    cumulativeXP: 1954,
    badge: false,
    reward: true,
    issueCardPack: true,
    infinityOnly: true,
  },
  {
    level: "16",
    incrementXP: 197,
    cumulativeXP: 2151,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "17",
    incrementXP: 207,
    cumulativeXP: 2358,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "18",
    incrementXP: 218,
    cumulativeXP: 2576,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "19",
    incrementXP: 229,
    cumulativeXP: 2805,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "20",
    incrementXP: 240,
    cumulativeXP: 3045,
    badge: false,
    reward: true,
    issueCardPack: true,
    infinityOnly: true,
  },
  {
    level: "21",
    incrementXP: 252,
    cumulativeXP: 3297,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "22",
    incrementXP: 265,
    cumulativeXP: 3562,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "23",
    incrementXP: 278,
    cumulativeXP: 3840,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "24",
    incrementXP: 292,
    cumulativeXP: 4132,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "25",
    incrementXP: 307,
    cumulativeXP: 4439,
    badge: true,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "26",
    incrementXP: 550,
    cumulativeXP: 4989,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "27",
    incrementXP: 578,
    cumulativeXP: 5567,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "28",
    incrementXP: 607,
    cumulativeXP: 6174,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "29",
    incrementXP: 637,
    cumulativeXP: 6811,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "30",
    incrementXP: 669,
    cumulativeXP: 7480,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "31",
    incrementXP: 702,
    cumulativeXP: 8182,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "32",
    incrementXP: 737,
    cumulativeXP: 8919,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "33",
    incrementXP: 774,
    cumulativeXP: 9693,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "34",
    incrementXP: 813,
    cumulativeXP: 10506,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "35",
    incrementXP: 854,
    cumulativeXP: 11360,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "36",
    incrementXP: 897,
    cumulativeXP: 12257,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "37",
    incrementXP: 942,
    cumulativeXP: 13199,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "38",
    incrementXP: 989,
    cumulativeXP: 14188,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "39",
    incrementXP: 1038,
    cumulativeXP: 15226,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "40",
    incrementXP: 1090,
    cumulativeXP: 16316,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "41",
    incrementXP: 1144,
    cumulativeXP: 17460,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "42",
    incrementXP: 1201,
    cumulativeXP: 18661,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "43",
    incrementXP: 1261,
    cumulativeXP: 19922,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "44",
    incrementXP: 1324,
    cumulativeXP: 21246,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "45",
    incrementXP: 1390,
    cumulativeXP: 22636,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "46",
    incrementXP: 1460,
    cumulativeXP: 24096,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "47",
    incrementXP: 1533,
    cumulativeXP: 25629,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "48",
    incrementXP: 1610,
    cumulativeXP: 27239,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "49",
    incrementXP: 1690,
    cumulativeXP: 28929,
    badge: false,
    reward: false,
    issueCardPack: false,
  },
  {
    level: "50",
    incrementXP: 1774,
    cumulativeXP: 30703,
    badge: true,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "51",
    incrementXP: 1863,
    cumulativeXP: 32566,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "52",
    incrementXP: 1956,
    cumulativeXP: 34522,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "53",
    incrementXP: 2054,
    cumulativeXP: 36576,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "54",
    incrementXP: 2157,
    cumulativeXP: 38733,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "55",
    incrementXP: 2265,
    cumulativeXP: 40998,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "56",
    incrementXP: 2378,
    cumulativeXP: 43376,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "57",
    incrementXP: 2497,
    cumulativeXP: 45873,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "58",
    incrementXP: 2622,
    cumulativeXP: 48495,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "59",
    incrementXP: 2753,
    cumulativeXP: 51248,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "60",
    incrementXP: 2891,
    cumulativeXP: 54139,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "61",
    incrementXP: 3036,
    cumulativeXP: 57175,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "62",
    incrementXP: 3188,
    cumulativeXP: 60363,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "63",
    incrementXP: 3347,
    cumulativeXP: 63710,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "64",
    incrementXP: 3514,
    cumulativeXP: 67224,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "65",
    incrementXP: 3690,
    cumulativeXP: 70914,
    badge: true,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "66",
    incrementXP: 3874,
    cumulativeXP: 74788,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "67",
    incrementXP: 4068,
    cumulativeXP: 78856,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "68",
    incrementXP: 4271,
    cumulativeXP: 83127,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "69",
    incrementXP: 4485,
    cumulativeXP: 87612,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "70",
    incrementXP: 4709,
    cumulativeXP: 92321,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "71",
    incrementXP: 4944,
    cumulativeXP: 97265,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "72",
    incrementXP: 5191,
    cumulativeXP: 102456,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "73",
    incrementXP: 5451,
    cumulativeXP: 107907,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "74",
    incrementXP: 5724,
    cumulativeXP: 113631,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "75",
    incrementXP: 6010,
    cumulativeXP: 119641,
    badge: true,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "76",
    incrementXP: 6310,
    cumulativeXP: 125951,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "77",
    incrementXP: 6626,
    cumulativeXP: 132577,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "78",
    incrementXP: 6957,
    cumulativeXP: 139534,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "79",
    incrementXP: 7305,
    cumulativeXP: 146839,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "80",
    incrementXP: 7670,
    cumulativeXP: 154509,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "81",
    incrementXP: 8054,
    cumulativeXP: 162563,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "82",
    incrementXP: 8457,
    cumulativeXP: 171020,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "83",
    incrementXP: 8880,
    cumulativeXP: 179900,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "84",
    incrementXP: 9324,
    cumulativeXP: 189224,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "85",
    incrementXP: 9790,
    cumulativeXP: 199014,
    badge: true,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "86",
    incrementXP: 10280,
    cumulativeXP: 209294,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "87",
    incrementXP: 10794,
    cumulativeXP: 220088,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "88",
    incrementXP: 11334,
    cumulativeXP: 231422,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "89",
    incrementXP: 11901,
    cumulativeXP: 243323,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "90",
    incrementXP: 12496,
    cumulativeXP: 255819,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "91",
    incrementXP: 13121,
    cumulativeXP: 268940,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "92",
    incrementXP: 13777,
    cumulativeXP: 282717,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "93",
    incrementXP: 14466,
    cumulativeXP: 297183,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "94",
    incrementXP: 15189,
    cumulativeXP: 312372,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "95",
    incrementXP: 15948,
    cumulativeXP: 328320,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "96",
    incrementXP: 16745,
    cumulativeXP: 345065,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "97",
    incrementXP: 17582,
    cumulativeXP: 362647,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "98",
    incrementXP: 18461,
    cumulativeXP: 381108,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "99",
    incrementXP: 19384,
    cumulativeXP: 400492,
    badge: false,
    reward: true,
    issueCardPack: false,
  },
  {
    level: "M1",
    incrementXP: 19384,
    cumulativeXP: 419876,
    badge: true,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M2",
    incrementXP: 19384,
    cumulativeXP: 439260,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M3",
    incrementXP: 19384,
    cumulativeXP: 458644,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M4",
    incrementXP: 19384,
    cumulativeXP: 478028,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M5",
    incrementXP: 19384,
    cumulativeXP: 497412,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M6",
    incrementXP: 19384,
    cumulativeXP: 516796,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M7",
    incrementXP: 19384,
    cumulativeXP: 536180,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M8",
    incrementXP: 19384,
    cumulativeXP: 555564,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M9",
    incrementXP: 19384,
    cumulativeXP: 574948,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
    level: "M10",
    incrementXP: 19384,
    cumulativeXP: 594332,
    badge: false,
    reward: true,
    issueCardPack: true,
  },
  {
  level: "M11",
  incrementXP: 22500,
  cumulativeXP: 616832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M12",
  incrementXP: 22500,
  cumulativeXP: 639332,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M13",
  incrementXP: 22500,
  cumulativeXP: 661832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M14",
  incrementXP: 22500,
  cumulativeXP: 684332,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M15",
  incrementXP: 22500,
  cumulativeXP: 706832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M16",
  incrementXP: 22500,
  cumulativeXP: 729332,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M17",
  incrementXP: 22500,
  cumulativeXP: 751832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M18",
  incrementXP: 22500,
  cumulativeXP: 774332,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M19",
  incrementXP: 22500,
  cumulativeXP: 796832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M20",
  incrementXP: 22500,
  cumulativeXP: 819332,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M21",
  incrementXP: 22500,
  cumulativeXP: 841832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M22",
  incrementXP: 22500,
  cumulativeXP: 864332,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M23",
  incrementXP: 22500,
  cumulativeXP: 886832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M24",
  incrementXP: 22500,
  cumulativeXP: 909332,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M25",
  incrementXP: 22500,
  cumulativeXP: 931832,
  badge: true, // milestone feels right here
  reward: true,
  issueCardPack: true,
},
{
  level: "M26",
  incrementXP: 25000,
  cumulativeXP: 956832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M27",
  incrementXP: 25000,
  cumulativeXP: 981832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M28",
  incrementXP: 25000,
  cumulativeXP: 1006832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M29",
  incrementXP: 25000,
  cumulativeXP: 1031832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M30",
  incrementXP: 25000,
  cumulativeXP: 1056832,
  badge: true,
  reward: true,
  issueCardPack: true,
},
{
  level: "M31",
  incrementXP: 25000,
  cumulativeXP: 1081832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M32",
  incrementXP: 25000,
  cumulativeXP: 1106832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M33",
  incrementXP: 25000,
  cumulativeXP: 1131832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M34",
  incrementXP: 25000,
  cumulativeXP: 1156832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M35",
  incrementXP: 25000,
  cumulativeXP: 1181832,
  badge: true,
  reward: true,
  issueCardPack: true,
},
{
  level: "M36",
  incrementXP: 25000,
  cumulativeXP: 1206832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M37",
  incrementXP: 25000,
  cumulativeXP: 1231832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M38",
  incrementXP: 25000,
  cumulativeXP: 1256832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M39",
  incrementXP: 25000,
  cumulativeXP: 1281832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M40",
  incrementXP: 25000,
  cumulativeXP: 1306832,
  badge: true,
  reward: true,
  issueCardPack: true,
},
{
  level: "M41",
  incrementXP: 25000,
  cumulativeXP: 1331832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M42",
  incrementXP: 25000,
  cumulativeXP: 1356832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M43",
  incrementXP: 25000,
  cumulativeXP: 1381832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M44",
  incrementXP: 25000,
  cumulativeXP: 1406832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M45",
  incrementXP: 25000,
  cumulativeXP: 1431832,
  badge: true,
  reward: true,
  issueCardPack: true,
},
{
  level: "M46",
  incrementXP: 25000,
  cumulativeXP: 1456832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M47",
  incrementXP: 25000,
  cumulativeXP: 1481832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M48",
  incrementXP: 25000,
  cumulativeXP: 1506832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M49",
  incrementXP: 25000,
  cumulativeXP: 1531832,
  badge: false,
  reward: true,
  issueCardPack: true,
},
{
  level: "M50",
  incrementXP: 25000,
  cumulativeXP: 1556832,
  badge: true, // big prestige cap
  reward: true,
  issueCardPack: true,
},
];

// export const levelXPTable = [
//   {
// 	level: "1",
// 	incrementXP: 0,
// 	cumulativeXP: 0,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "2",
// 	incrementXP: 100,
// 	cumulativeXP: 100,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "3",
// 	incrementXP: 105,
// 	cumulativeXP: 205,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "4",
// 	incrementXP: 110,
// 	cumulativeXP: 315,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "5",
// 	incrementXP: 115,
// 	cumulativeXP: 430,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "6",
// 	incrementXP: 121,
// 	cumulativeXP: 551,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "7",
// 	incrementXP: 127,
// 	cumulativeXP: 678,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "8",
// 	incrementXP: 134,
// 	cumulativeXP: 812,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "9",
// 	incrementXP: 140,
// 	cumulativeXP: 952,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "10",
// 	incrementXP: 147,
// 	cumulativeXP: 1099,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "11",
// 	incrementXP: 155,
// 	cumulativeXP: 1254,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "12",
// 	incrementXP: 162,
// 	cumulativeXP: 1416,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "13",
// 	incrementXP: 171,
// 	cumulativeXP: 1587,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "14",
// 	incrementXP: 179,
// 	cumulativeXP: 1766,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "15",
// 	incrementXP: 188,
// 	cumulativeXP: 1954,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "16",
// 	incrementXP: 197,
// 	cumulativeXP: 2151,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "17",
// 	incrementXP: 207,
// 	cumulativeXP: 2358,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "18",
// 	incrementXP: 218,
// 	cumulativeXP: 2576,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "19",
// 	incrementXP: 229,
// 	cumulativeXP: 2805,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "20",
// 	incrementXP: 240,
// 	cumulativeXP: 3045,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "21",
// 	incrementXP: 252,
// 	cumulativeXP: 3297,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "22",
// 	incrementXP: 265,
// 	cumulativeXP: 3562,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "23",
// 	incrementXP: 278,
// 	cumulativeXP: 3840,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "24",
// 	incrementXP: 292,
// 	cumulativeXP: 4132,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "25",
// 	incrementXP: 307,
// 	cumulativeXP: 4439,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "26",
// 	incrementXP: 550,
// 	cumulativeXP: 4989,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "27",
// 	incrementXP: 578,
// 	cumulativeXP: 5567,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "28",
// 	incrementXP: 607,
// 	cumulativeXP: 6174,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "29",
// 	incrementXP: 637,
// 	cumulativeXP: 6811,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "30",
// 	incrementXP: 669,
// 	cumulativeXP: 7480,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "31",
// 	incrementXP: 702,
// 	cumulativeXP: 8182,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "32",
// 	incrementXP: 737,
// 	cumulativeXP: 8919,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "33",
// 	incrementXP: 774,
// 	cumulativeXP: 9693,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "34",
// 	incrementXP: 813,
// 	cumulativeXP: 10506,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "35",
// 	incrementXP: 854,
// 	cumulativeXP: 11360,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "36",
// 	incrementXP: 897,
// 	cumulativeXP: 12257,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "37",
// 	incrementXP: 942,
// 	cumulativeXP: 13199,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "38",
// 	incrementXP: 989,
// 	cumulativeXP: 14188,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "39",
// 	incrementXP: 1038,
// 	cumulativeXP: 15226,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "40",
// 	incrementXP: 1090,
// 	cumulativeXP: 16316,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "41",
// 	incrementXP: 1144,
// 	cumulativeXP: 17460,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "42",
// 	incrementXP: 1201,
// 	cumulativeXP: 18661,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "43",
// 	incrementXP: 1261,
// 	cumulativeXP: 19922,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "44",
// 	incrementXP: 1324,
// 	cumulativeXP: 21246,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "45",
// 	incrementXP: 1390,
// 	cumulativeXP: 22636,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "46",
// 	incrementXP: 1460,
// 	cumulativeXP: 24096,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "47",
// 	incrementXP: 1533,
// 	cumulativeXP: 25629,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "48",
// 	incrementXP: 1610,
// 	cumulativeXP: 27239,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "49",
// 	incrementXP: 1690,
// 	cumulativeXP: 28929,
// 	badge: false,
// 	reward: false,
// 	issueCardPack: false,
//   },
//   {
// 	level: "50",
// 	incrementXP: 1774,
// 	cumulativeXP: 30703,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "51",
// 	incrementXP: 1863,
// 	cumulativeXP: 32566,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "52",
// 	incrementXP: 1956,
// 	cumulativeXP: 34522,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "53",
// 	incrementXP: 2054,
// 	cumulativeXP: 36576,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "54",
// 	incrementXP: 2157,
// 	cumulativeXP: 38733,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "55",
// 	incrementXP: 2265,
// 	cumulativeXP: 40998,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "56",
// 	incrementXP: 2378,
// 	cumulativeXP: 43376,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "57",
// 	incrementXP: 2497,
// 	cumulativeXP: 45873,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "58",
// 	incrementXP: 2622,
// 	cumulativeXP: 48495,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "59",
// 	incrementXP: 2753,
// 	cumulativeXP: 51248,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "60",
// 	incrementXP: 2891,
// 	cumulativeXP: 54139,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "61",
// 	incrementXP: 3036,
// 	cumulativeXP: 57175,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "62",
// 	incrementXP: 3188,
// 	cumulativeXP: 60363,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "63",
// 	incrementXP: 3347,
// 	cumulativeXP: 63710,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "64",
// 	incrementXP: 3514,
// 	cumulativeXP: 67224,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "65",
// 	incrementXP: 3690,
// 	cumulativeXP: 70914,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "66",
// 	incrementXP: 3874,
// 	cumulativeXP: 74788,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "67",
// 	incrementXP: 4068,
// 	cumulativeXP: 78856,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "68",
// 	incrementXP: 4271,
// 	cumulativeXP: 83127,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "69",
// 	incrementXP: 4485,
// 	cumulativeXP: 87612,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "70",
// 	incrementXP: 4709,
// 	cumulativeXP: 92321,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "71",
// 	incrementXP: 4944,
// 	cumulativeXP: 97265,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "72",
// 	incrementXP: 5191,
// 	cumulativeXP: 102456,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "73",
// 	incrementXP: 5451,
// 	cumulativeXP: 107907,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "74",
// 	incrementXP: 5724,
// 	cumulativeXP: 113631,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "75",
// 	incrementXP: 6010,
// 	cumulativeXP: 119641,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "76",
// 	incrementXP: 6310,
// 	cumulativeXP: 125951,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "77",
// 	incrementXP: 6626,
// 	cumulativeXP: 132577,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "78",
// 	incrementXP: 6957,
// 	cumulativeXP: 139534,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "79",
// 	incrementXP: 7305,
// 	cumulativeXP: 146839,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "80",
// 	incrementXP: 7670,
// 	cumulativeXP: 154509,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "81",
// 	incrementXP: 8054,
// 	cumulativeXP: 162563,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "82",
// 	incrementXP: 8457,
// 	cumulativeXP: 171020,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "83",
// 	incrementXP: 8880,
// 	cumulativeXP: 179900,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "84",
// 	incrementXP: 9324,
// 	cumulativeXP: 189224,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "85",
// 	incrementXP: 9790,
// 	cumulativeXP: 199014,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "86",
// 	incrementXP: 10280,
// 	cumulativeXP: 209294,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "87",
// 	incrementXP: 10794,
// 	cumulativeXP: 220088,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "88",
// 	incrementXP: 11334,
// 	cumulativeXP: 231422,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "89",
// 	incrementXP: 11901,
// 	cumulativeXP: 243323,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "90",
// 	incrementXP: 12496,
// 	cumulativeXP: 255819,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "91",
// 	incrementXP: 13121,
// 	cumulativeXP: 268940,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "92",
// 	incrementXP: 13777,
// 	cumulativeXP: 282717,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "93",
// 	incrementXP: 14466,
// 	cumulativeXP: 297183,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "94",
// 	incrementXP: 15189,
// 	cumulativeXP: 312372,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "95",
// 	incrementXP: 15948,
// 	cumulativeXP: 328320,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "96",
// 	incrementXP: 16745,
// 	cumulativeXP: 345065,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "97",
// 	incrementXP: 17582,
// 	cumulativeXP: 362647,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "98",
// 	incrementXP: 18461,
// 	cumulativeXP: 381108,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "99",
// 	incrementXP: 19384,
// 	cumulativeXP: 400492,
// 	badge: false,
// 	reward: true,
// 	issueCardPack: false,
//   },
//   {
// 	level: "M1",
// 	incrementXP: 19384,
// 	cumulativeXP: 419876,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M2",
// 	incrementXP: 19384,
// 	cumulativeXP: 439260,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M3",
// 	incrementXP: 19384,
// 	cumulativeXP: 458644,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M4",
// 	incrementXP: 19384,
// 	cumulativeXP: 478028,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M5",
// 	incrementXP: 19384,
// 	cumulativeXP: 497412,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M6",
// 	incrementXP: 19384,
// 	cumulativeXP: 516796,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M7",
// 	incrementXP: 19384,
// 	cumulativeXP: 536180,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M8",
// 	incrementXP: 19384,
// 	cumulativeXP: 555564,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M9",
// 	incrementXP: 19384,
// 	cumulativeXP: 574948,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
//   {
// 	level: "M10",
// 	incrementXP: 19384,
// 	cumulativeXP: 594332,
// 	badge: true,
// 	reward: true,
// 	issueCardPack: true,
//   },
// ];
